import { auth } from '../providers/Firebase';
import firebase from 'firebase/app';
import userService from './UserService';
import { User } from 'models/User';

class AuthService {
  private fAuth = auth();

  user() {
    return this.fAuth.currentUser;
  }

  isAuthenticated(): boolean {
    return JSON.parse(localStorage.getItem('isLogged') || 'false')
  }

  observeAuth(invoke: (isAuth: boolean) => any) {
    return this.fAuth.onAuthStateChanged(
      user => {
        invoke(user?.uid != null)
      },
      error => {
        invoke(false)
      }
    )
  }

  async signInWithEmail(email: string, pass: string) {
    const data = await this.fAuth.signInWithEmailAndPassword(email, pass);
    this.setHasLogged(true)

    return data
  }

  async signUpWithEmail(name: string, email: string, pass: string) {
    const data = await this.fAuth.createUserWithEmailAndPassword(email, pass);

    data.user!.updateProfile({ displayName: name })

    this.setHasLogged(true)

    return data
  }

  private setHasLogged(isLogged: boolean) {
    localStorage.setItem('isLogged', `${isLogged}`)
  }

  private setExitToLoginWithProvider(exited: boolean) {
    localStorage.setItem('exitToLoginWithProvider', `${exited}`)
  }

  async signInWithGoogle() {
    this.setExitToLoginWithProvider(true)
    console.log('Sign in with google');

    const googleProvideLogin = new firebase.auth.GoogleAuthProvider()
    googleProvideLogin.addScope('profile');
    googleProvideLogin.addScope('email');

    console.log(this.fAuth.tenantId)

    googleProvideLogin.setCustomParameters({
      prompt: 'select_account',
    })

    await this.fAuth.signInWithRedirect(googleProvideLogin);
  }

  signOut() {
    // Has temporary error https://github.com/firebase/firebase-js-sdk/issues/158
    return new Promise((resolve, reject) => {
      try {
        this.fAuth.signOut().then(() => {
          resolve(null)
        })
      } catch (error) {
        console.log(error);

        reject(error)
      }
    })
  }

  async recoveryCredentialsInRedirect() {
    try {
      const res = await this.fAuth.getRedirectResult()

      this.setHasLogged(true)
      this.setExitToLoginWithProvider(false)

      this.fAuth.signInWithCredential(res.credential!)

      console.log('Novo login via provider');

      await userService.saveIfNoExists(User.userFromAuthUser(this.fAuth.currentUser!))

    } catch (error) {
      console.log('Erro no login', error);
    }
  }
}

export default new AuthService();
